import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatButtonModule } from "@angular/material/button";
import { MatInputModule } from "@angular/material/input";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { SnackbarModule } from "@onsip/web/features/shared/components/snackbar/snackbar.module";
import { TranslateModule } from "@ngx-translate/core";
import { RouterModule } from "@angular/router";
import { ContactComponent } from "./contact.component";
import { ContactEditComponent } from "./contact-edit/contact-edit.component";
import { ContactRoutingModule } from "./contact-routing.module";
import { ContactViewComponent } from "./contact-view/contact-view.component";
import { MatSelectModule } from "@angular/material/select";
import { OnsipFormsModule } from "@onsip/web/features/shared/components/forms/onsip-forms.module";
import { PipesModule } from "@onsip/web/features/shared/pipes/pipes.module";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { LoadingContainerComponent } from "@onsip/web/features/shared/components/loadingContainer/loading-container.component";

@NgModule({
  declarations: [ContactComponent, ContactViewComponent, ContactEditComponent],
  imports: [
    CommonModule,
    ContactRoutingModule,
    RouterModule,
    FormsModule,
    TranslateModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatButtonModule,
    MatInputModule,
    MatSelectModule,
    OnsipFormsModule,
    PipesModule,
    SnackbarModule,
    MatCheckboxModule,
    MatProgressSpinnerModule,
    LoadingContainerComponent
  ]
})
export class ContactModule {}
